import React, {  useCallback, useRef, useState, useMemo } from 'react'
import { useLocation } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { TopToolbar, Filter,useDelete, Pagination, useListPaginationContext, PaginationActions, ReferenceInput, TextInput, useTranslate, Datagrid, AutocompleteInput, List, useListContext, useLocaleState, NumberInput, SelectInput } from 'react-admin'

import { Box, Typography, ListSubheader, ListItemButton, ListItem, IconButton, useTheme, Slide, useMediaQuery, Button, Dialog, DialogContent, TablePagination  } from '@mui/material'
import Map, { LocationsMap } from '../../../ui/maps/map'
import { PER_PAGE_MAP, isAdminPermissions, isSuperAdmin } from '../../../helper/resourceHelper'
import { autocompleteInputCommonStyle, listMapCommonStyle, numberInputCommonStyle, searchInputCommonStyle, selectInputCommonStyle, textInputCommonStyle } from '../../../themes/commonStyles'
import SearchInputLabelComponent from '../../../ui/inputs/SearchInputLabelComponent'
import { OptionsBtn } from '../../../ui/button/OptionsBtn'
import LoadingDialog from '../../../ui/dialog/LoadingDialog';
import StandardDialog from '../../../ui/dialog/StandardDialog';
import { getDateTimeToFullLocalString } from '../../../utils/date';
import { AddBtnWithOptionalMenu } from '../../../ui/button/AddBtn';




const MenuCustomListSubheader = ({
}) => {
    const theme = useTheme();
    const translate = useTranslate();
    let options = []
    
    const {
        isLoading,
        hasNextPage,
        page,
        perPage,
        total,
        setPage,
        setPerPage,
    } = useListPaginationContext();

    const totalPages = useMemo(() => {
        return total != null ? Math.ceil(total / perPage) : undefined;
    }, [perPage, total]);
    const handlePageChange = useCallback(
        (event, page) => {
            event && event.stopPropagation();
            if (page < 0 || page > totalPages - 1) {
                throw new Error(
                    translate('ra.navigation.page_out_of_boundaries', {
                        page: page + 1,
                    })
                );
            }
            setPage(page + 1);
        },
        [totalPages, setPage, translate]
    );

    const labelDisplayedRows = useCallback(
        ({ from, to, count }) =>
            count === -1 && hasNextPage
                ? translate('ra.navigation.partial_page_range_info', {
                    offsetBegin: from,
                    offsetEnd: to,
                    _: `%{from}-%{to} of more than %{to}`,
                })
                : translate('ra.navigation.page_range_info', {
                    offsetBegin: from,
                    offsetEnd: to,
                    total: count === -1 ? to : count,
                    _: `%{from}-%{to} of %{count === -1 ? to : count}`,
                }),
        [translate, hasNextPage]
    );

    const labelItem = useCallback(
        type => translate(`ra.navigation.${type}`, { _: `Go to ${type} page` }),
        [translate]
    );

    if (isLoading) {
        return null;
    }

    // Avoid rendering TablePagination if "page" value is invalid
    if (total === 0 || page < 1 || (total != null && page > totalPages)) {
        if (limit != null && process.env.NODE_ENV === 'development') {

        }
        return null;
    }

    return (
        <ListSubheader
            component="div"
            sx={{
                padding: "0px 0px 0px 0px",
                margin: "0px",
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
            }}>


            <Box sx={{
                padding: "0px",
                margin: "0px 0px 0px 4px",
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
            }}>

                <TablePagination
                    count={total == null ? -1 : total}
                    rowsPerPage={perPage}
                    rowsPerPageOptions={[]}
                    page={page - 1}
                    ActionsComponent={(rest) => <PaginationActions siblingCount={0} boundaryCount={1} color="primary"{...rest} />}
                    onPageChange={handlePageChange}
                    slotProps={{
                        actions: {
                            nextButton: { disabled: !hasNextPage }
                        }
                    }}



                    sx={{
                        width: "100%",
                        margin: "0px 0px 0px 0px",
                        display: "flex",
                        padding: "0px",
                        alignItems: "flex-start",
                        flexDirection: "row",
                        justifyContent: "center",
                        "& .MuiToolbar-root": {
                            boxShadow: "none !important",
                            flexDirection: "column",
                            margin: "0px !important",
                            padding: "0px !important",
                            "&.MuiToolbar-root.MuiTablePagination-toolbar": {
                                padding: "0px !important",
                                minHeight: "0px  !important",
                            }
                        },
                        "& .MuiTablePagination-displayedRows": {
                            margin: "0px !important",
                            fontWeight: 500
                        },
                        "& .MuiTablePagination-actions": {
                            margin: "0px !important",
                            fontSize: "10px"
                        }
                    }}
                    component="span"
                    labelRowsPerPage={""}
                    labelDisplayedRows={labelDisplayedRows}
                    getItemAriaLabel={labelItem}
                />
            </Box>
            <Box sx={{ flex: 1 }} />
            <Box sx={{
                padding: "0px",
                margin: "10px 10px 0px 0px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
                lineHeight: "18.75px"
            }} >

                <OptionsBtn width={"24"} height={"24"} menuItems={options} />
            </Box>
        </ListSubheader>
    )
}


const MenuCustomListItemNumberIcon = ({ number, color }) => {
    const theme = useTheme();
    let fontSizeText = "16px";
    if (number > 0 && number < 10) {
        fontSizeText = "16px";
    }
    if (number > 9 && number < 100) {
        fontSizeText = "16px";
    }
    if (number > 99 && number < 1000) {
        fontSizeText = "14px";
    }
    if (number > 999) {
        fontSizeText = "12px";
    }
    return (

        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="8" fill={color} />
            {number != null && number > 0 && <g>
                <text x="50%" y="50%" font-family="Roboto" font-size={fontSizeText} dominant-baseline="middle" text-anchor="middle" font-weight="bold" fill="white">{number}</text>
            </g>}
        </svg>



    )
}



const MenuCustomListItemLocationIcon = ({ color }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_12_39822)">
                <path d="M8.00033 5.3335C7.26699 5.3335 6.66699 5.9335 6.66699 6.66683C6.66699 7.40016 7.26699 8.00016 8.00033 8.00016C8.73366 8.00016 9.33366 7.40016 9.33366 6.66683C9.33366 5.9335 8.73366 5.3335 8.00033 5.3335ZM8.00033 1.3335C5.20033 1.3335 2.66699 3.48016 2.66699 6.80016C2.66699 9.0135 4.44699 11.6335 8.00033 14.6668C11.5537 11.6335 13.3337 9.0135 13.3337 6.80016C13.3337 3.48016 10.8003 1.3335 8.00033 1.3335ZM8.00033 12.8868C5.30033 10.4202 4.00033 8.36016 4.00033 6.7935C4.00033 4.38016 5.76699 2.66683 8.00033 2.66683C10.2337 2.66683 12.0003 4.38016 12.0003 6.80016C12.0003 8.36016 10.7003 10.4268 8.00033 12.8868Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_12_39822">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}



const MenuCustomListItemSatelliteIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-satellite">
            <path stroke="none" d="M0 0h16v16H0z" fill="none" strokeWidth="0.6666666666666666" />
            <path d="m2.471 4.195 1.724 -1.724a0.667 0.667 0 0 1 0.943 0l3.724 3.724a0.667 0.667 0 0 1 0 0.943l-1.724 1.724a0.667 0.667 0 0 1 -0.943 0L2.471 5.138a0.667 0.667 0 0 1 0 -0.943" />
            <path d="m4 6.667 -2 2 2 2 2 -2" />
            <path d="m6.667 4 2 -2 2 2 -2 2" />
            <path d="m8 8 1 1" />
            <path d="M9.667 11.333a1.667 1.667 0 0 0 1.667 -1.667" />
            <path d="M10 14a4 4 0 0 0 4 -4" /></svg>


    )
}



const MenuCustomListItem = ({ location, number, theme, translate, handleSelect, selected, isMobile }) => {
    
    const [openIconChangeDialog, setOpenIconChangeDialog] = useState(false);
    const record = location.record
    const [deleteOne] = useDelete();
    const seletecBgColor = theme.palette.mode === "light" ? theme.palette.primary.light : theme.palette.background.paper;
    let options = []
    const handleDelete = () => {
        if (window.confirm("Are you sure you want to delete this item?")) {
            deleteOne(
                'mac_addresses', 
                { id: record.id },
                {
                    onSuccess: () => {
                        notify('Deleted successfully', { type: 'info' });
                        refresh();
                    },
                    onError: (error) => {
                        notify(`Error: ${error.message}`, { type: 'warning' });
                    },
                }
            );
        }
    };
    
    options.push({
        label: translate('resources.mac_addresses.edit'),
        path: `/mac_addresses/${record.id}/edit`
    })
    
    options.push({
        label: translate('resources.mac_addresses.delete'),
        onClick: handleDelete,
    })
    
    
    let locationText = null;
    let formattedAddressText = null;



    if (record.address.latitude && record.address.longitude) {
        locationText = `${record.address.latitude}, ${record.address.longitude}`;
    }
    if (record.address.formatted_address) {
        formattedAddressText = record.address.formatted_address.length > 25 ? `${record.address.formatted_address.substring(0, 24)}...` : record.address.formatted_address;
    }

    return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
        <ListItemButton
            id={`menu-custom-list-item-${record.id}`}
            button
            onClick={() => {
                handleSelect(location)
            }}
            sx={{
                backgroundColor: selected ? seletecBgColor : theme.palette.background.paper,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                padding: "12px",
                margin: "0px",
                borderRadius: isMobile ? "12px" : 0
            }} >
            <MenuCustomListItemNumberIcon number={number} color={theme.palette.primary.main} />
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                padding: "0px",
                margin: "0px 10px 0px 10px"
            }}>

                <Typography sx={{ color: theme.palette.text.primary, fontSize: "14px", fontWeight: 500, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", alignmentBaseline: "central", margin: "0px 0px 0px 0px", padding: "0px" }} >{record.mac_address}</Typography>
                



                {locationText &&
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            padding: "0px",
                            margin: "0px"
                        }}>
                        <MenuCustomListItemSatelliteIcon color={theme.palette.text.secondary} />
                        <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "2px 0px 2px 5px", padding: "0px" }} >{locationText}</Typography>

                    </Box>
                }
                {formattedAddressText &&
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            padding: "0px",
                            margin: "0px"
                        }}>
                        <MenuCustomListItemLocationIcon color={theme.palette.text.secondary} />
                        <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "2px 0px 2px 5px", padding: "0px" }} >{formattedAddressText}</Typography>

                    </Box>
                }




            </Box>
            <Box sx={{ flex: 1 }} />
             <OptionsBtn width={"24"} height={"24"} menuItems={options} />
        </ListItemButton>
        <StandardDialog open={openIconChangeDialog} onClose={() => { }} fullWidth={false}
            
        /> 
    </Box >
}



const LoadingPopUp = ({ }) => {
    const { isPending, isFetching, isLoading } = useListContext();
    return (
        <LoadingDialog
            isPending={isPending}
            isFetching={isFetching}
            isLoading={isLoading}
        />
    )

};

const MacAddressListActions = () => {
    const { resource } = useListContext();
    const translate = useTranslate();
    const addBtnMenuItems = []

    if (isSuperAdmin() || isROAdmin()) {
        addBtnMenuItems.push({
            label: translate('resources.mac_addresses.create'),
            path: `/${resource}/create`
        })
    }

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row"

        }}>

            <AddBtnWithOptionalMenu menuItems={addBtnMenuItems} isMobile={false} />
        </Box>
    )
}

const MacAddressList = ({ classes, ...props }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();

    const macAddressFromUrl = useMemo(() => {
        const value = new URLSearchParams(location.search).get('mac_address');
        return value || undefined;
    }, [location.search]);

    const iconColorMap = {
        parameterKey: "mac_address",
        matchingList: [
            {
                isTrue: (mac_address) => true,
                color: "#09630c",
                name: "addressIconUrl_24x24",

            },
        ]

    }


    if (isMobile) return null
    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: isMobile ? "0px 0px 0px 0px" : "0px 0px 16px 0px" }}>
                {translate('resources.mac_addresses.name', { smart_count: 2 })}
            </Typography>
            <List
                
                {...props}
                disableSyncWithLocation
                title={translate('resources.mac_addresses.name', { smart_count: 2 })}
                sx={listMapCommonStyle({ theme, isMobile, noActions: isMobile })}
                resource='mac_addresses'
                actions={<MacAddressListActions />}
                filterDefaultValues={macAddressFromUrl ? { mac_address: macAddressFromUrl } : undefined}
                filters={<Filter {...props} >
                    <TextInput
                        id="outlined-basic-size-small"
                        source="mac_address"
                        alwaysOn
                        sx={numberInputCommonStyle({ theme })}
                        label={translate('resources.mac_addresses.fields.mac_address')}
                    />


                </Filter>
                }
                filter={{
                    radius_meters: 100
                }}
                pagination={false}
            >

                <LocationsMap
                    isMobile={false}
                    MenuCustomListItem={MenuCustomListItem}
                    MenuCustomListSubheader={MenuCustomListSubheader}
                    translate={translate}
                    allowRouting={false}
                    latKey={"address.latitude"}
                    longKey={"address.longitude"}
                    formattedAddressKey={"address.formatted_address"}
                    iconColorMap={iconColorMap}
                    handleMapClickWithSetFilters={({ e, setFilters }) => {
                        if (e && e.latlng && e.latlng.lat && e.latlng.lng) {
                            setFilters({ latitude: e.latlng.lat, longitude: e.latlng.lng }, undefined, false)
                        }
                    }}
                />
                <LoadingPopUp />
                
            </List>
        </>
    )
}

export default MacAddressList